import { enums, mask } from 'superstruct';
export const ARC_ENVIRONMENT_NAMES = ['dev', 'staging', 'prod'];
const publicEnvironment = process.env.NX_PUBLIC_ENVIRONMENT || 'dev';
function validateEnv(env) {
  try {
    return mask(env.trim(), enums(ARC_ENVIRONMENT_NAMES));
  } catch {
    throw new Error(`Invalid NX_PUBLIC_ENVIRONMENT: ${env}. Must be one of ${ARC_ENVIRONMENT_NAMES.join(', ')}`);
  }
}
export const ARC_ENVIRONMENT = validateEnv(publicEnvironment);